
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Des petits frères`}</em></p>
    <p>{`La Chine développe d'autres vaccins. Parmi eux, on peut mentionner le Coronavac,
qui a été validé début juin par
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news/item/01-06-2021-who-validates-sinovac-covid-19-vaccine-for-emergency-use-and-issues-interim-policy-recommendations"
      }}>{`l'OMS`}</a>{`,
pour une utilisation d'urgence. Développé par une compagnie nommée Sinovac, il a
été créé à partir de virus inactivé et nécessite deux injections.`}</p>
    <p>{`Selon l'OMS, il prévient les formes symptomatiques du Covid dans 51% des cas et
permet d'éviter les formes graves et l'hospitalisation dans 100% de la
population étudiée. Toutefois, peu de personnes de plus de 60 ans ont participé
aux essais cliniques: il n'a donc pas été possible d'estimer l'efficacité du
vaccin dans ce groupe d'âge.`}</p>
    <p>{`Dans cette famille chinoise, on trouve aussi le produit de CanSino Biologics.
Pour l'anecdote, le vice-président et responsable marketing de ce laboratoire
est un Vaudois. Officiellement nommé Convidecia (ou Ad5-nCoV), ce vaccin a été
créé en collaboration avec l'Institut de biologie de l'académie nationale des
sciences médicales militaires.`}</p>
    <p>{`Convidecia, qui utilise la technique du vecteur viral (voir l'explication dans
la fiche d'AstraZeneca) ne nécessite qu'une injection. Pékin lui a délivré le 25
février 2021 une autorisation conditionnelle pour une utilisation dans
l'urgence. Selon ses producteurs, il permet d'éviter une infection avec des
symptomes dans environ 65% des cas. Ce vaccin est notamment utilisé au Pakistan,
en Hongrie et au Mexique.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;